import React, { FC } from 'react';
import { useCourse } from 'contexts/course.context';
import { useTranslation } from 'react-i18next';
import {
    Left,
    Price,
    PriceTitle,
    Right,
    TitleWrapper,
    PriceDescription,
    ButtonCourses,
    EmptyBlock,
} from './styled';
import { CoursePrice } from 'types';
import DOMPurify from 'dompurify';
import { SectionTitle } from '../../styled';
import { SpeakersButton } from 'containers/pages/for-businesses/components/speakers/styled';
import {
    ButtonLinkGreenInner,
    ButtonLinkInner,
} from 'containers/pages/for-businesses/components/test/styled';
import { CourseTemplate } from 'types/enums';

interface PricesProps {
    openRegistrationModal: () => void;
}

export const Prices: FC<PricesProps> = ({ openRegistrationModal }) => {
    const { t } = useTranslation('pages/courses');
    const { course } = useCourse();

    const isXTraining = course?.template === CourseTemplate.XTraining;

    return (
        <>
            <TitleWrapper>
                <SectionTitle>{t('prices')}</SectionTitle>

                <ButtonCourses>
                    {isXTraining && (
                        <ButtonLinkInner
                            as={'a'}
                            href={course?.buyLink}
                            target={'_blank'}>
                            {t('buy-myself')}
                        </ButtonLinkInner>
                    )}
                    <SpeakersButton
                        onClick={openRegistrationModal}
                        variant={'contained'}
                        color={'primary-contrast'}
                        styles={{ height: '48px' }}>
                        {course?.template === CourseTemplate.Product
                            ? t('find-a-provider')
                            : isXTraining
                            ? t('team-order')
                            : t('registration-modal-title')}
                    </SpeakersButton>
                    {isXTraining && (
                        <ButtonLinkGreenInner
                            as={'a'}
                            href={course?.demoLink}
                            target={'_blank'}>
                            {t('demo-request')}
                        </ButtonLinkGreenInner>
                    )}
                </ButtonCourses>
            </TitleWrapper>

            {course?.prices.map((price: CoursePrice) => (
                <Price key={price.id}>
                    <Left>
                        <PriceTitle
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(price.name),
                            }}
                        />
                        <PriceDescription>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        price.description
                                    ),
                                }}
                            />
                        </PriceDescription>
                    </Left>

                    <Right>
                        <PriceDescription
                            styles={{ fontSize: '16px', lineHeight: '18px' }}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        price.additionalDescription
                                    ),
                                }}
                            />
                            <EmptyBlock />
                        </PriceDescription>
                    </Right>
                </Price>
            ))}
        </>
    );
};
